import React from 'react';
import { Form, Label, Dropdown } from 'semantic-ui-react';

const DropDownInput = ({input, defaultValue, value, placeholder, multiple, options, meta: {touched, error}}) => {
  return (
    <Form.Field error={touched && !!error}>
      <Dropdown
        onChange={(e, data) => input.onChange(data.value)}
        fluid selection
        placeholder={placeholder}
        options={options}
        defaultValue={defaultValue}
      />
      {touched && error && <Label basic color='red'>{error}</Label>}
    </Form.Field>
  )
}

export default DropDownInput;
